import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=5117a131&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=5117a131&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117a131",
  null
  
)

export default component.exports